import { render } from "./addTemplate.vue?vue&type=template&id=2b0ce5a0"
import script from "./addTemplate.vue?vue&type=script&lang=js"
export * from "./addTemplate.vue?vue&type=script&lang=js"

import "./addTemplate.vue?vue&type=style&index=0&id=2b0ce5a0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__